import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import ServiceImportTemplate from '../../../components/5templates/ServiceImportTemplate'
import {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'
import {getItemFromSessionStorage, removeAllItemsInSessionStorage, setItemToSessionStorage} from '../../../services/util/sessionStorageManager'
import {
    formatExistingServiceSearch,
    areAllObjectValuesEmpty,
    serviceListFormatter
} from '../../../services/util/miscellaneousService'
import ApiService from '../../../common/ApiCalls'
import {FeedbackSnackbar} from '../../../components/1elements'
import LoaderBackdrop from '../../../components/2compounds/LoaderBackdrop'

const ImportServiceForm = () => {
    const navigate = useNavigate()
    const [serviceList, setServiceList] = useState({})
    const [selectedServiceType, setSelectedServiceType] = useState('')
    const [selectedServiceTypeId, setSelectedServiceTypeId] = useState('')
    const [searchKeyword, setSearchKeyword] = useState('')
    const [options, setOptions] = useState([])
    const [snackbar, setSnackbar] = useState({isOpen: false, severity: "", message: "Information is successfully saved!"})
    const [formCheckSnackbar, setFormCheckSnackbar] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [approver, setApprover] = useState(null)
    const [showError, setShowError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)

    const onSave = () => {
        if(approver){
            setIsModalOpen(false)
            setIsLoading(true)
            const {'location_id': id} = getItemFromSessionStorage('selectedLocation')
            const {'account_id': accountId} = getItemFromSessionStorage('selectedClient')
            const selectedServiceList = getItemFromSessionStorage('selectedServiceList')
            const initiatorId = localStorage.getItem('userId')
            const initiatorEmail = localStorage.getItem('email')
            const pendingDataId = getItemFromSessionStorage('pendingDataId')

            const data = {
                accountId,
                pendingDataId: pendingDataId ? pendingDataId : '',
                initiatorId,
                initiatorEmail,
                approverId: approver['user_id'],
                id:  id,
                selectedServiceList: serviceListFormatter(selectedServiceList)
            }

            ApiService().linkExistingServicesToExistingLocation(data)
                .then(()=>{
                    const data = {email: approver.email, name: approver.username}
                    ApiService().notifyApprover(data)
                        .catch((err)=>{
                            console.log(err)
                        })
                })
                .then(()=>{
                    setLoaded(true)
                    setSnackbar(prevState => {return {...prevState, severity: 'success', isOpen: true}})
                    window.setTimeout(()=>{
                        onCancel()
                    }, 2000)
                })
                .catch((err)=>{
                    console.log(err)
                    setSnackbar(prevState => {return {...prevState, severity: 'fail', isOpen: true}})
                })
        }else{
            setShowError(true)
        }
    }
    const onCancel = () => {
        removeAllItemsInSessionStorage()
        navigate('/adminDashboard')
    }
    const onPrev = () => {
        setItemToSessionStorage('selectedServiceList', serviceList)
        navigate('/adminDashboard')
    }
    const onNext = () => {
        setItemToSessionStorage('selectedServiceList', serviceList)
        if(!areAllObjectValuesEmpty(serviceList)){
            setIsModalOpen(true)
        }else{
            setFormCheckSnackbar(true)
        }
    }

    useEffect(()=> {
        if(searchKeyword.length){
            const data = {
                name: searchKeyword,
                typeId: selectedServiceTypeId
            }

            ApiService().getServiceByNameAndType(data)
                .then((res)=>{
                    const formattedResult = formatExistingServiceSearch(res)
                    setOptions(formattedResult)
                })
                .catch((err)=>{
                    console.log(err)
                })
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [searchKeyword])

    useEffect(()=>{
        setOptions([])
    }, [selectedServiceType])

    return (
        <DataImportFormTabs flow={'addService'}>
            <ServiceImportTemplate serviceList={serviceList} setServiceList={setServiceList}
                                   onPrev={onPrev} onNext={onNext} onSave={onSave} options={options}
                                   selectedServiceType={selectedServiceType} setSelectedServiceType={setSelectedServiceType}
                                   setSelectedServiceTypeId={setSelectedServiceTypeId} setSearchKeyword={setSearchKeyword}
                                   setOptions={setOptions} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}
                                   approver={approver} setApprover={setApprover} formCheckSnackbar={formCheckSnackbar}
                                   setFormCheckSnackbar={setFormCheckSnackbar} showError={showError}/>
            <FeedbackSnackbar setSnackbar={setSnackbar} snackbar={snackbar} />
            <LoaderBackdrop open={isLoading} loaded={loaded} />
        </DataImportFormTabs>
    )
}

export default ImportServiceForm
